import React from 'react';
import styles from './Category.module.scss';
import CategoriesSection from '../../organisms/categoriesSection/CategoriesSection';

interface PopularCategory {
  categoryImage?: string;
  categoryUrl?: string;
  teaserText?: string;
  teaserDescription?: string;
  titleStyles?: Record<string, unknown>;
  descriptionStyles?: Record<string, unknown>;
  mobileCategoryImage?: string;
  subcats?: unknown[];
  isFeatured?: boolean;
  contentAlignment?: string;
  imageHeightLg?: number;
  imageHeightMd?: number;
  imageHeightsm?: number;
}

interface EmptyCategoryProps {
  popularCategories?: PopularCategory[];
}

export const EmptyCategory: React.FC<EmptyCategoryProps> = ({ popularCategories }) => {
  const hasPopularCategories = !!popularCategories?.[0]?.categoryImage;

  return (
    <div>
      <div className={styles.emptySearchTitle}>
        <h2>{`We can't seem to find what you're looking for ...`}</h2>
        {hasPopularCategories && <p>Try these links instead:</p>}
      </div>
      {hasPopularCategories && (
        // @ts-ignore
        <CategoriesSection isArrowRight withoutScroll categories={popularCategories} />
      )}
    </div>
  );
};
